import type { IBaseAdmin } from "../../BaseAdminFactory";
import type { DocumentType } from "le-coffre-resources/dist/Admin";
import type { QueryPayload } from "@Front/Api/types";
import type { IGetDocumentTypesparams, IPutDocumentTypesParams, IPostDocumentTypesParams } from "../DocumentTypes";
import {
	buildDocumentTypesCreatePayload,
	buildDocumentTypesUpdatePayload,
} from "@Front/Api/LeCoffreApi/helpers/businessRequestPayloadHelpers";

export function createGetMethod(baseAdmin: IBaseAdmin, baseUrl: string) {
	return async (q: IGetDocumentTypesparams): Promise<DocumentType[]> => {
		const url = new URL(baseUrl);
		const query = { q };
		if (q) baseAdmin.appendJsonSearchParams(url, query);
		try {
			return await baseAdmin.getRequest<DocumentType[]>(url);
		} catch (err) {
			baseAdmin.onError(err);
			return Promise.reject(err);
		}
	};
}

export function createPostMethod(baseAdmin: IBaseAdmin, baseUrl: string) {
	return async (body: IPostDocumentTypesParams): Promise<DocumentType> => {
		const url = new URL(baseUrl);
		try {
			const payload = buildDocumentTypesCreatePayload(body);
			return await baseAdmin.postRequest<DocumentType>(url, payload);
		} catch (err) {
			baseAdmin.onError(err);
			return Promise.reject(err);
		}
	};
}

export function createGetByUidMethod(baseAdmin: IBaseAdmin, baseUrl: string) {
	return async (uid: string, q?: QueryPayload): Promise<DocumentType> => {
		const url = new URL(baseUrl.concat(`/${uid}`));
		const query = { q };
		if (q) baseAdmin.appendJsonSearchParams(url, query);
		try {
			return await baseAdmin.getRequest<DocumentType>(url);
		} catch (err) {
			baseAdmin.onError(err);
			return Promise.reject(err);
		}
	};
}

export function createPutMethod(baseAdmin: IBaseAdmin, baseUrl: string) {
	return async (uid: string, body: IPutDocumentTypesParams): Promise<DocumentType> => {
		const url = new URL(baseUrl.concat(`/${uid}`));
		try {
			const payload = buildDocumentTypesUpdatePayload(body);
			return await baseAdmin.putRequest<DocumentType>(url, payload);
		} catch (err) {
			baseAdmin.onError(err);
			return Promise.reject(err);
		}
	};
}
